export default {
  setEmail: (state, email) => {
    state.email = email;
  },
  setFirstname: (state, firstname) => {
    state.firstname = firstname;
  },
  setLastname: (state, lastname) => {
    state.lastname = lastname;
  },
  setFullName: (state, fullName) => {
    state.fullName = fullName;
  },
  setError: (state, error) => {
    state.error = error;
  },
  setUserConfirmed: (state, userConfirmed) => {
    state.userConfirmed = userConfirmed;
  },
  setSignupDone: (state, signupDone) => {
    state.signupDone = signupDone;
  },
  setShowForgotPassword: (state, showForgotPassword) => {
    state.showForgotPassword = showForgotPassword;
  },
  setShowEmailSent: (state, showEmailSent) => {
    state.showEmailSent = showEmailSent;
  },
  setShowGuidanceTooltip: (state, showGuidanceTooltip) => {
    state.showGuidanceTooltip = showGuidanceTooltip;
  },
  setFastspringAccountId: (state, fastspringAccountId) => {
    state.fastspringAccountId = fastspringAccountId;
  },
  setActiveSubscription: (state, activeSubscription) => {
    state.activeSubscription = activeSubscription;
  },
  setAccountManagementURL: (state, accountManagementURL) => {
    state.accountManagementURL = accountManagementURL;
  },
};
